export default "__VITE_ASSET__B1sP_8Pe__"